export enum RouteNames {
  HOME = '/',
  LOGIN = '/login',
  NOT_FOUND = '/*',
  MESSAGES = '/messages',
  PROFILE = '/profile/:userId',
  ME = '/me',
  FRIENDS = '/friends',
  MUSIC = '/music',
  SETTINGS = '/settings',
}
